import React, { FunctionComponent } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import isEmpty from 'lodash/isEmpty'
import isNumber from 'lodash/isNumber'

import styles from './styles.module.css'

export interface TileProps {
  title: string
  value?: string
  loading: boolean
}

const Tile: FunctionComponent<TileProps> = ({ title, value, loading }) => {
  const displayValue = !isEmpty(value) || isNumber(value) ? value : '---'

  return (
    <div className={styles.container} data-rv="performance-tile">
      <h5 data-rv="performance-tile-title">{title.toUpperCase()}</h5>
      <div className={styles.value} data-rv="performance-tile-value">
        {!loading ? (
          displayValue
        ) : (
          <FontAwesomeIcon
            icon={['fas', 'spinner']}
            pulse
            className={styles.loading}
          />
        )}
      </div>
    </div>
  )
}

export default Tile
